import { createSlice } from '@reduxjs/toolkit';
import { userLogin } from './actions/userAction';

const initialState = {
  loading: false,
  userInfo: {}, // for user object
  userToken: null, // for storing the JWT
  error: null,
  success: false, // for monitoring the login process.
}


export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    logout: (state) => {
      localStorage.removeItem('userToken') // deletes token from storage
      localStorage.removeItem('refreshToken') // deletes refresh token from storage
      state.loading = false
      state.userInfo = null
      state.userToken = null
      state.error = null
    },
    updateToken: (state, { payload }) => {
      state.userInfo = { ...state.userInfo, accessToken: payload }
      state.userToken = payload
    },
  },
  extraReducers: {
    // login user
    [userLogin.pending]: (state) => {
      state.loading = true
      state.success = false
      state.error = null
    },
    [userLogin.fulfilled]: (state, { payload }) => {
      state.loading = false
      state.success = true
      state.userInfo = payload
      state.userToken = payload.userToken
    },
    [userLogin.rejected]: (state, { payload }) => {
      state.loading = false
      state.success = false
      state.error = payload
    },
  }
})

// Action creators are generated for each case reducer function
export const { logout, updateToken } = userSlice.actions

export default userSlice.reducer